export const allowDevTools =
  process.env.NODE_ENV === 'development' ||
  window?.origin === 'https://labscoop.dev.angleto.com';

export const ignoreSuppliers = [
  {
    id: 'fa0212e5-da9d-4f78-99a2-dba6c9a07c0b',
    title: 'Plant Cell Technology',
    context: ['suppliers_list', 'filters', 'links'],
  },
  // {
  //   id: '0e94cc0c-a4d1-4ae0-9cdd-f1e9d942fb15',
  //   title: 'Redoxica',
  //   context: ['suppliers_list', 'links'],
  // },
  {
    id: '02b3e07a-2dd8-4654-8d0a-d86a4597b038',
    title: 'Nanovex Biotechnologies SL',
    context: ['suppliers_list', 'links'],
  },
];
